import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { AttendanceRecord, ChildDetail } from '@/hooks/use-parent-data';
import { AttendanceTimeline } from '@/components/shared/attendance-timeline';

interface AttendanceTabProps {
  attendance: AttendanceRecord[];
  stats: ChildDetail['stats'];
}

export function AttendanceTab({ attendance, stats }: AttendanceTabProps) {
  return (
    <div className="space-y-4">
      {/* Stats Overview */}
      <Card>
        <CardHeader>
          <CardTitle>Attendance Summary (Last 30 Days)</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="text-center p-3 bg-muted/40 rounded-lg">
              <p className="text-2xl font-bold">{stats.attendanceStats.total}</p>
              <p className="text-sm text-muted-foreground">Total Sessions</p>
            </div>
            <div className="text-center p-3 bg-green-50 dark:bg-green-950/30 rounded-lg">
              <p className="text-2xl font-bold text-green-600">{stats.attendanceStats.present}</p>
              <p className="text-sm text-muted-foreground">Present</p>
            </div>
            <div className="text-center p-3 bg-yellow-50 dark:bg-yellow-950/30 rounded-lg">
              <p className="text-2xl font-bold text-yellow-600">{stats.attendanceStats.late}</p>
              <p className="text-sm text-muted-foreground">Late</p>
            </div>
            <div className="text-center p-3 bg-red-50 dark:bg-red-950/30 rounded-lg">
              <p className="text-2xl font-bold text-red-600">{stats.attendanceStats.absent}</p>
              <p className="text-sm text-muted-foreground">Absent</p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Attendance List */}
      <Card>
        <CardHeader>
          <CardTitle>Recent Attendance</CardTitle>
        </CardHeader>
        <CardContent>
          <AttendanceTimeline records={attendance} />
        </CardContent>
      </Card>
    </div>
  );
}
